import { DataState } from 'types/store/reducers/dataSources';
import { CustomerActions } from 'types/store/actions/customers';
import { CustomerActionTypes } from 'types/store/actions/constants';
import { Customer } from 'types';

export const initialState: DataState<Customer> = {
  data: {},
};

export default (
  state = initialState,
  action: CustomerActions
): DataState<Customer> => {
  switch (action.type) {
    case CustomerActionTypes.FETCH_SUCCESS: {
      const customer = action.payload;
      const data = { [customer.id]: customer };
      return {
        ...state,
        data,
      };
    }
    default:
      return state;
  }
};
